import { Form, InputNumber } from "antd";

import { REGEX } from "~/core/constants/common";
import { parseShorthandAmount } from "~/core/generic/numeric-utils";

import { useGlobalNewOpportunityModalContext } from "../../context";
import { useInputKeyDown } from "../../hooks/useInputKeyDown";

interface Props {
  name: string;
  label: string;
  placeholder?: string;
}

export default function Amount({ name, label, placeholder }: Props) {
  const { amountRef } = useGlobalNewOpportunityModalContext();
  const { handleKeyDown } = useInputKeyDown();

  return (
    <Form.Item name={name} label={label}>
      <InputNumber
        ref={amountRef}
        prefix="$"
        placeholder={placeholder}
        className="!w-full"
        formatter={value => {
          if (!value) return "";
          // Preserve original decimal places
          const [whole, decimal] = value.toString().split(".");
          const formattedWhole = Number(whole).toLocaleString("en-US");
          return `${formattedWhole}${decimal ? `.${decimal}` : ""}`;
        }}
        parser={value => {
          if (!value) return "";
          try {
            const cleanValue = value.replace(REGEX.CURRENCY_FORMAT, "");
            const parsedValue = parseShorthandAmount(cleanValue);
            return isNaN(parsedValue) ? "" : parsedValue;
          } catch {
            return "";
          }
        }}
        step={0.01}
        controls={false}
        onKeyDown={handleKeyDown}
      />
    </Form.Item>
  );
}
